import { Card, Stack, Typography } from '@mui/material';
import { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fromSecondsToTimerFormat } from 'src/common/utils/format-utils';
import useStyles from './styles';

interface TestTimerProps {
  left: number;
  onEnd: () => void;
}

export const TestTimer: ComponentType<TestTimerProps> = ({ left, onEnd }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [leftInSeconds, setLeftInSeconds] = useState<number>(0);
  const [timerInterval, setTimerInterval] = useState<any>(null);

  const handleStartTimer = () => {
    const interval = setInterval(() => {
      if (leftInSeconds > 1) {
        setLeftInSeconds((prev) => prev - 1);
      } else {
        onEnd();
      }
    }, 1000);
    setTimerInterval(interval);
  };

  const handleEndTimer = () => {
    if (timerInterval) {
      clearInterval(timerInterval);
      setTimerInterval(null);
    }
  };

  useEffect(() => {
    if (left && left > 0) setLeftInSeconds(left - 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [left]);

  useEffect(() => {
    if (leftInSeconds > 0 && !timerInterval) handleStartTimer();
    return handleEndTimer;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leftInSeconds, timerInterval]);

  return (
    <Card className={classes.root}>
      <Stack direction="row" alignItems="center">
        <Typography variant="h5" mr={1}>
          {t('timeLeft', 'Времени до конца')}:
        </Typography>
        <Typography variant="h3" color="primary">
          {fromSecondsToTimerFormat(leftInSeconds)}
        </Typography>
      </Stack>
    </Card>
  );
};
